import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=67e44242&scoped=true"
import script from "./fail.vue?vue&type=script&lang=js"
export * from "./fail.vue?vue&type=script&lang=js"
import style0 from "./fail.vue?vue&type=style&index=0&id=67e44242&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e44242",
  null
  
)

export default component.exports